<template>
  <section class="section container pt-0">
    <verification-datatable />
  </section>
</template>

<script>
import VerificationDatatable from "./verification_datatable/Index.vue";

export default {
  name: "IdentityIndex",
  components: {
    VerificationDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
